export const headCells = [
    {id: 'idLotto', label: 'ID lotto',tooltipLabel:"In caso di distribuzione digitale con cambio formato contestuale puoi verificare l’esito cambio formato utilizzando come filtro l’ID lotto."},
    {id: 'numeroDiTelefono', label: 'N. Telefono'},
    {id: 'seriale', label: 'Seriale'},
    {id: 'email', label: 'Indirizzo email'},
    {id: 'dataInvio', label: 'Data invio'},
    {id: 'esitoInvio', label: 'Esito invio',width:"12%"},
];
